import { render, staticRenderFns } from "./pumpkin.vue?vue&type=template&id=316ff011&"
import script from "./pumpkin.vue?vue&type=script&lang=js&"
export * from "./pumpkin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports